var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 638,
    viewBox: "0 0 295 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.333 10.6663C273.333 16.5573 278.109 21.333 284 21.333C289.891 21.333 294.667 16.5573 294.667 10.6663C294.667 4.77525 289.891 -0.000378609 284 -0.000378609C278.109 -0.000378609 273.333 4.77525 273.333 10.6663ZM273.333 626.574C273.333 632.465 278.109 637.241 284 637.241C289.891 637.241 294.667 632.465 294.667 626.574C294.667 620.683 289.891 615.908 284 615.908C278.109 615.908 273.333 620.683 273.333 626.574ZM284 10.6663L284.046 8.66682C188.989 6.46915 117.79 43.5714 70.4527 100.677C23.159 157.73 -0.225612 234.628 0.00164509 311.981C0.228909 389.337 24.0688 467.32 71.4481 526.569C118.863 585.862 189.798 626.313 283.952 628.574L284 626.574L284.048 624.575C191.108 622.343 121.27 582.467 74.572 524.071C27.8387 465.63 4.22665 388.56 4.00163 311.97C3.7766 235.377 26.9395 159.437 73.5322 103.23C120.081 47.0755 190.107 10.4961 283.954 12.6658L284 10.6663Z",
    fill: "url(#paint0_linear_11766_28481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11766_28481",
    x1: 143,
    y1: 10.5742,
    x2: 143,
    y2: 626.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809ECA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1);
export default __webpack_public_path__ + "static/media/line1.57d60106a9f742e723efbbe673bd2120.svg";
export { ForwardRef as ReactComponent };